// src/slices/10-forms/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { sendForm, sendMeetingform, sendBookingForm, sendConsultingForm } from "./thunk";

const formReducer = createSlice({
  name: "form",
  initialState: {
    // Training Form
    loading: false,
    success: false,
    error: null,
    data: null,

    // Meeting Form
    meetingLoading: false,
    meetingSuccess: false,
    meetingError: null,
    meetingData: null,

    // Booking Form
    bookingLoading: false,
    bookingSuccess: false,
    bookingError: null,
    bookingData: null,

    // Consulting Form
    consultingLoading: false,
    consultingSuccess: false,
    consultingError: null,
    consultingData: null
  },
  reducers: {
    resetForm: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
    resetMeetingForm: (state) => {
      state.meetingLoading = false;
      state.meetingSuccess = false;
      state.meetingError = null;
      state.meetingData = null;
    },
    resetBookingForm: (state) => {
      state.bookingLoading = false;
      state.bookingSuccess = false;
      state.bookingError = null;
      state.bookingData = null;
    },
    resetConsultingForm: (state) => {
      state.consultingLoading = false;
      state.consultingSuccess = false;
      state.consultingError = null;
      state.consultingData = null;
    }
  },
  extraReducers: (builder) => {
    // -------------------------------------
    // Training Form
    // -------------------------------------
    builder
      .addCase(sendForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(sendForm.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        if (action.payload) {
          state.error = typeof action.payload === "string" ? { message: action.payload } : action.payload.message ? { message: action.payload.message } : { message: JSON.stringify(action.payload) };
        }
      });

    // -------------------------------------
    // Meeting Form
    // -------------------------------------
    builder
      .addCase(sendMeetingform.pending, (state) => {
        state.meetingLoading = true;
        state.meetingSuccess = false;
        state.meetingError = null;
      })
      .addCase(sendMeetingform.fulfilled, (state, action) => {
        state.meetingLoading = false;
        state.meetingSuccess = true;
        state.meetingData = action.payload;
        state.meetingError = null;
      })
      .addCase(sendMeetingform.rejected, (state, action) => {
        state.meetingLoading = false;
        state.meetingSuccess = false;
        if (action.payload) {
          state.meetingError = typeof action.payload === "string" ? { message: action.payload } : action.payload.message ? { message: action.payload.message } : { message: JSON.stringify(action.payload) };
        }
      });

    // -------------------------------------
    // Booking Form
    // -------------------------------------
    builder
      .addCase(sendBookingForm.pending, (state) => {
        state.bookingLoading = true;
        state.bookingSuccess = false;
        state.bookingError = null;
      })
      .addCase(sendBookingForm.fulfilled, (state, action) => {
        state.bookingLoading = false;
        state.bookingSuccess = true;
        state.bookingData = action.payload;
        state.bookingError = null;
      })
      .addCase(sendBookingForm.rejected, (state, action) => {
        state.bookingLoading = false;
        state.bookingSuccess = false;
        if (action.payload) {
          state.bookingError = typeof action.payload === "string" ? { message: action.payload } : action.payload.message ? { message: action.payload.message } : { message: JSON.stringify(action.payload) };
        }
      });

    // -------------------------------------
    // Consulting Form
    // -------------------------------------
    builder
      .addCase(sendConsultingForm.pending, (state) => {
        state.consultingLoading = true;
        state.consultingSuccess = false;
        state.consultingError = null;
      })
      .addCase(sendConsultingForm.fulfilled, (state, action) => {
        state.consultingLoading = false;
        state.consultingSuccess = true;
        state.consultingData = action.payload;
        state.consultingError = null;
      })
      .addCase(sendConsultingForm.rejected, (state, action) => {
        state.consultingLoading = false;
        state.consultingSuccess = false;
        if (action.payload) {
          state.consultingError = typeof action.payload === "string" ? { message: action.payload } : action.payload.message ? { message: action.payload.message } : { message: JSON.stringify(action.payload) };
        }
      });
  }
});

export const { resetForm, resetMeetingForm, resetBookingForm, resetConsultingForm } = formReducer.actions;

export default formReducer.reducer;
